// Az appban megjelenített összehasonlító görbék EGYETLEN, forrásolt adatforrása.
// Minden érték a docs/KLINIKAI_ADATOK.md-ből származik — új szám ide csak a
// dokumentum frissítésével együtt kerülhet be, ne fordítva.

export type Gyogyszer = "tirzepatide" | "semaglutide";
export type ClinicalPopulation = "testsulycsokkenes" | "cukorbetegseg";

export interface ClinicalDoseEndpoint {
  doseMg: number;
  /** Testsúlyváltozás %-ban a vizsgálat végpontján, negatív = fogyás. */
  pctChange: number;
}

export interface ClinicalReferenceBranch {
  id: string;
  gyogyszer: Gyogyszer;
  population: ClinicalPopulation;
  trialName: string;
  populationLabel: string;
  /** A vizsgálat időtávja hétben — a görbe ennyi hétig fut. */
  weeks: number;
  doses: ClinicalDoseEndpoint[];
  comparatorLabel: string;
  comparatorPct: number;
  source: string;
  lastChecked: string;
  /**
   * true, ha az érték nem közvetlenül publikált %, hanem a forrás abszolút
   * (kg/font) adataiból számolt közelítés — lásd KLINIKAI_ADATOK.md 2. szakasz.
   */
  derived?: boolean;
}

export const CLINICAL_REFERENCE: ClinicalReferenceBranch[] = [
  {
    id: "surmount-1",
    gyogyszer: "tirzepatide",
    population: "testsulycsokkenes",
    trialName: "SURMOUNT-1",
    populationLabel: "elhízás-populáció, cukorbetegek nélkül",
    weeks: 72,
    doses: [
      { doseMg: 5, pctChange: -15.0 },
      { doseMg: 10, pctChange: -19.5 },
      { doseMg: 15, pctChange: -20.9 },
    ],
    comparatorLabel: "placebo",
    comparatorPct: -3.1,
    source:
      "Jastreboff AM, Aronne LJ, Ahmad NN, et al., for the SURMOUNT-1 Investigators. Tirzepatide Once Weekly for the Treatment of Obesity. N Engl J Med. 2022;387(3):205–216. doi:10.1056/NEJMoa2206038 (NCT04184622)",
    lastChecked: "2026-08-17",
  },
  {
    id: "surpass-2",
    gyogyszer: "tirzepatide",
    population: "cukorbetegseg",
    trialName: "SURPASS-2",
    populationLabel: "2-es típusú cukorbetegség, metformin mellett",
    weeks: 40,
    doses: [
      { doseMg: 5, pctChange: -8.3 },
      { doseMg: 10, pctChange: -10.0 },
      { doseMg: 15, pctChange: -12.1 },
    ],
    comparatorLabel: "Ozempic 1 mg",
    comparatorPct: -6.3,
    source: "mounjaro.lilly.com/hcp/clinical-data (SURPASS-2)",
    lastChecked: "2026-08-17",
    derived: true,
  },
  {
    id: "step-1",
    gyogyszer: "semaglutide",
    population: "testsulycsokkenes",
    trialName: "STEP 1",
    populationLabel: "elhízás/túlsúly, cukorbetegség nélkül",
    weeks: 68,
    doses: [{ doseMg: 2.4, pctChange: -14.9 }],
    comparatorLabel: "placebo",
    comparatorPct: -2.4,
    source:
      "Fornes A, Huff J, Pritchard RI, Godfrey M. Once-Weekly Semaglutide for Weight Management: A Clinical Review. J Pharm Technol. 2022;38(4):239–246. doi:10.1177/87551225221092681 — PMC9272494",
    lastChecked: "2026-08-17",
  },
  {
    id: "step-2",
    gyogyszer: "semaglutide",
    population: "cukorbetegseg",
    trialName: "STEP 2",
    populationLabel: "túlsúly/elhízás + 2-es típusú cukorbetegség",
    weeks: 68,
    doses: [
      { doseMg: 1.0, pctChange: -7.0 },
      { doseMg: 2.4, pctChange: -9.6 },
    ],
    comparatorLabel: "placebo",
    comparatorPct: -3.4,
    source:
      "Fornes A, Huff J, Pritchard RI, Godfrey M. Once-Weekly Semaglutide for Weight Management: A Clinical Review. J Pharm Technol. 2022;38(4):239–246. doi:10.1177/87551225221092681 — PMC9272494",
    lastChecked: "2026-08-17",
  },
];
